export default __webpack_public_path__ + "static/contribuimos-a7be1b1e8b6ceca784a095b986123642.png";